import styled from 'styled-components';
import React, { FC } from 'react';
import { Colors } from '../../../styles/colors';

const CheckboxContainer = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  vertical-align: middle;
`;

const Icon = styled.svg`
  fill: none;
  stroke: white;
  stroke-width: 2px;
`;

const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
  border: 0;
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`;

const StyledCheckbox = styled.div<{ checked: boolean, disabled: boolean }>`
  display: inline-block;
  width: 1rem;
  height: 1rem;
  box-shadow: inset 0 0 0 1px ${({ checked = false, disabled = false }) => (checked ? (disabled ? 'none' : Colors.primary) : Colors.grayDark)};
  background: ${({ checked = false, disabled = false }) => (checked ? (disabled ? Colors.grayMid : Colors.primary) : Colors.white)};
  transition: all 150ms;
  
  :hover {
    cursor: pointer;
  }

  ${HiddenCheckbox}:focus + & {
    box-shadow: 0 0 0 3px ${Colors.primaryLight};
  }

  ${Icon} {
    visibility: ${props => (props.checked ? 'visible' : 'hidden')}
  }
`;

export interface CheckboxProps {
  checked: boolean;
  id: string;
  disabled?: boolean;
  onChange: (checked: boolean) => void;
}

export const Checkbox: FC<CheckboxProps> = (props) => {
  const { checked, disabled, onChange } = props;
  return (
    <CheckboxContainer>
      <HiddenCheckbox
        checked={checked}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
          onChange(event.target.checked);
        }}/>
      <StyledCheckbox
        checked={checked}
        disabled={disabled}
        onClick={() => {
          onChange(!checked);
        }}>
        <Icon viewBox="0 0 24 24">
          <polyline points="20 6 9 17 4 12"/>
        </Icon>
      </StyledCheckbox>
    </CheckboxContainer>);
};
